export function getState() {
  return window._vm &&
    window._vm.$store &&
    window._vm.$store.state &&
    window._vm.$store.state.navHeader;
}

export function commit_update_navheaderactive(navHeaderActive) {
  window._vm.$store && window._vm.$store.commit("navHeader/UPDATE_NAVHEADERACTIVE", navHeaderActive);
}

export function commit_update_cacheNavheader(historyNavheader) {
  window._vm.$store && window._vm.$store.commit("navHeader/UPDATE_CACHENAVHEADER", historyNavheader);
}



// WEBPACK FOOTER //
// ./src/wenxing/store/navHeaderStateUtil.js